import {useState} from 'react'
import ProductRequestList from './ProductRequestList';
import ProductRequestForm from './ProductRequestForm';

const ProductRequest = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <ProductRequestForm addForm={setFromIsShown} update={upData} />
      ) : (
        <ProductRequestList addForm={setFromIsShown} update={setUpData} />
      )}

  </>
  )
}

export default ProductRequest